(() => {
  const retailVolumeDiscountIds = new Set(['48832', '48835', '48838', '48839', '49867']);
  const appstleConfig = window._ABConfig;

  if (!appstleConfig || !Array.isArray(appstleConfig.bundle_rules)) return;

  appstleConfig.bundle_rules = appstleConfig.bundle_rules.map((rule) => {
    if (!retailVolumeDiscountIds.has(String(rule?.id))) return rule;
    const retailRule = { ...rule, restrictTags: null };
    if (String(rule.id) === '49867' && rule.name === 'FREE SHIPPING OVER $100  Clone') {
      retailRule.name = 'FREE SHIPPING OVER $100';
    }
    return retailRule;
  });
})();
